import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Spinner } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import { Link, useSearchParams } from 'react-router-dom';

const HOME_URL = 'https://tn.licorne-academy.com';

const PaypalSuccess = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      const PayerID = searchParams.get('PayerID');
      const paymentId = searchParams.get('paymentId');

      if (!PayerID || !paymentId) {
        setError(true);
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `/api/paypal/success?PayerID=${PayerID}&paymentId=${paymentId}`
        );
        const data = await response.json();
        setPaymentDetails(data);
      } catch (err) {
        console.error('Error fetching payment details:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentDetails();
  }, [searchParams]);

  useEffect(() => {
    if (loading) return undefined;
    const timer = setTimeout(() => {
      window.location.href = HOME_URL;
    }, 10000);
    return () => clearTimeout(timer);
  }, [loading]);

  if (loading) {
    return (
      <div className='payment-status-page'>
        <div className='status-panel success'>
          <Spinner animation='border' className='status-spinner' />
          <p className='status-redirect mt-3'>
            {t('redirecting') || 'Chargement...'}
          </p>
        </div>
      </div>
    );
  }

  if (error || !paymentDetails) {
    return (
      <div className='payment-status-page'>
        <div className='status-panel fail'>
          <h1>{t('payfail')}</h1>
          <p>
            {t('payment_failed_message') ||
              'Error loading payment details. Please try again.'}
          </p>
          <div className='status-actions'>
            <Link to='/cart' className='btn btn-teal'>
              {t('returnCart') || 'Retour au panier'}
            </Link>
            <Link to='/' className='btn btn-outline-teal'>
              {t('return')}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const amount = paymentDetails.transactions?.[0]?.amount;

  return (
    <div className='payment-status-page'>
      <div className='status-panel success'>
        <img src='/licorne.png' alt='Licorne' className='status-brand-logo' />
        <div className='status-icon success-icon'>
          <FaCheckCircle />
        </div>
        <h1>{t('paysucc')}</h1>
        <p>
          {t('payment_success_message') ||
            'Thank you for your payment. Here are your payment details:'}
        </p>

        <div className='payment-details-card'>
          <p>
            <strong>Transaction ID:</strong> {paymentDetails.id || 'N/A'}
          </p>
          <p>
            <strong>Payer:</strong>{' '}
            {paymentDetails.payer?.payer_info?.first_name}{' '}
            {paymentDetails.payer?.payer_info?.last_name}
          </p>
          <p>
            <strong>Email:</strong>{' '}
            {paymentDetails.payer?.payer_info?.email || 'N/A'}
          </p>
          <p>
            <strong>Amount:</strong> {amount?.total || 'N/A'}{' '}
            {amount?.currency || ''}
          </p>
        </div>

        <div className='status-actions'>
          <Button className='btn-teal' onClick={() => window.print()}>
            {t('printReceipt') || 'Imprimer le reçu'}
          </Button>
          <Button
            className='btn-outline-teal'
            onClick={() => (window.location.href = HOME_URL)}
          >
            {t('redirect_now') || 'Rediriger maintenant'}
          </Button>
        </div>
        <p className='status-redirect mt-3'>
          {t('redirecting') || 'Redirection en cours...'}
        </p>
      </div>
    </div>
  );
};

export default PaypalSuccess;
